/**
 * @internal
 */
export enum Operations {
    add = '+',
    addAuto = '±',
    remove = '-',
    system = '$', // for $params, $settings?
    modify = '%',
    // comment = '/',
}
